export default __webpack_public_path__ + "static/media/GR00032-mentor_amulet_1.09b53f80.svg";